export enum ResponceErrorCode {
    NoError = 0,
    UserAddressNotFound = 1,
    StoreNotDefined = 2,
    StoreNotFound = 3,
    CartIsEmpty = 4,
    DeviceNotFound = 5,
    PromoAlreadyApplied = 10,
    MerchantIsNotApproved = 11,
    PromoNotAvailable = 12,
    AnotherRiderIsAssigned = 14,
    OrderIsCanceled = 15,
    OrderHasWrongStatus = 16,
    OrderNotFound = 17,
    ZeroDeliveryFee = 18,
    MerchantIsSuspended = 19,
    NotEnoughMoney = 20,
    FrequentApiCall = 21,
    ExceededOrdersPerMin = 22,
    RiderHasAnotherAction = 23,
    RiderHasNoOffer = 24,
    DriverLicenseExpired = 25,
    InvalidReferralCode = 26,
    InvalidRefferal2wQuest = 27,
    NullParameterPassed = 28,
    UserIdRequired = 29,
    UserCanOnlyClearHisCart = 30,
    RiderNotFound = 31,
    UserNotFound = 32,
    TokensDoNotMatch = 33,
    DisciplinaryNotFound = 34,
    SomethingWentWrong = 35,
    PromoNotFound = 36,
    MerchantIdDoesNotMatch = 37,
    MerchantNotFound = 38,
    UserExists = 39,
    UnknownUser = 40,
    MerchantIdDoesNotMatchCurrent = 41,
    NotImplemented = 42,
    NotSupportedFileExtension = 43,
    FormFileEmpty = 44,
    RequestCannotBeEmpty = 45,
    PinCodeIsWrong = 46,
    InputFieldIsEmpty = 47,
    ConfirmationPasswordIsWrong = 48,
    OTPExpired = 49,
    DriverNotPartOfLoopPassCohort = 50,
    EntryNotFound = 51,
    LimitExceeded = 52,
    AccessDenied = 53,
    DriverCannotAcceptNonSubscriptionOrder = 54,
    InsufficientFingerprintCondidenceScore = 55,
    FingerprintProcessingError = 56,
    InvalidQRPinCode = 57,
    TransferOrderNotFound = 58,
    RecordExists = 59,
    GuestAlreadyExists = 60,
    UserHasNoAccessToMerchant = 61,
    BadRequest = 62,
    AlreadyExist = 63,
    NotFound = 64,
    ExceededScheduledOrdersPerDay = 65,
    StoreTypeNotDefined = 66,
    WrongFileFormat = 67,
    InternalError = 68,
    UnsupportedMediaType = 69,
    NameEmpty = 70,
    InvalidDocument = 71,
    UserValidationFailed = 72,
    UserSuspended = 73,
    UserBanned = 74,
    PriceChanged = 75,
    ConnexCancellationRequiresSupport = 76,
    ExceededConnexOrders = 77,
    PaymentFailed = 78,
    DriverHaveActiveBooking = 79,
    BookingWindowClosed = 80,
    VehicleNotFound = 81,
    RiderVehicleServiceType = 82,
    RiderDetailsAreCurrentlyEdited = 83,
}
